import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { JobportalComponent } from './jobportal/jobportal.component';
import { JobdetailComponent } from './jobdetail/jobdetail.component';
import { ApplicationComponent } from './application/application.component';
import { SuccessComponent } from './success/success.component';
import { AuthGuard } from '../auth/auth.guard';
import { PermissionGuard } from '../auth/permission.guard';

const routes: Routes = [
  { path: '', component: JobportalComponent, canActivate: [PermissionGuard], data: { permission: 'view_all_jobs' } },
  { path: 'job-detail', component: JobdetailComponent, canActivate: [PermissionGuard], data: { permission: 'view_job_details' }   },
  {
    path: 'application',
    component: ApplicationComponent,
    children: [
      { path: 'success', component: SuccessComponent, canActivate: [PermissionGuard], data: { permission: 'apply_for_job' } },
    ],
    canActivate: [PermissionGuard],
    data: { permission: 'apply_for_job' }
   },
  { path: 'applications', 
    loadChildren: () => import('./applications/applications.module').then(m => m.ApplicationsModule), canActivate: [AuthGuard] },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class JobportalRoutingModule { }
